export enum ActivityRelationType {
  PARTNER =  'PARTNER',
  PUBLIC = 'PUBLIC',
  OTHER = 'OTHER',
  EXTERNAL = 'EXTERNAL'
}
